import React from "react";
import {Modal} from 'react-bootstrap'

// import '../compMainStyles.css';
import './confirmationModalComp.css';

/**
 * ConfirmationModalComp component
 * @param {Object} props - ConfirmationModalComp properties
 * @param {Boolean} props.isOpen - boolean that determines whether to display the modal
 * @param {Function} props.handleCloseModal - function that handles the closing of the modal
 * @param {Function} props.handleSubmit - function that executes when the submit button is clicked
 * @param {String} props.title - string that is used for the title displayed at the top of the modal
 * @param {String} props.message - string that is used for the message that prompts the user for action
 * @param {String} props.submitButtonLabel - string that is used for the label on the submit button
 * @param {String} [props.optionalThirdButtonLabel] - (Optional) string that is used for the label on the third button
 * @param {Function} [props.optionalThirdOption] - (Optional) function that executes if the third button is clicked
 * @param {Function} [props.setOptionalThirdButtonLabel] - (Optional) react hook used to set the optional third button label
 * @returns {JSX.Element} the rendered component
 */

const ConfirmationModalComp = ( props ) => {

    const { 
        isOpen, 
        handleCloseModal, 
        handleSubmit, 
        title, 
        message, 
        submitButtonLabel, 
        optionalThirdButtonLabel, 
        optionalThirdOption, 
        setOptionalThirdButtonLabel 
    } = props;


    const handleOnHide = () => {
        handleCloseModal()
        if(optionalThirdButtonLabel && optionalThirdButtonLabel !== ""){
            setOptionalThirdButtonLabel("")
        }
    }

return (
        <>
            <Modal
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={isOpen}
                onHide={handleOnHide}
            >
                <Modal.Header>
                    <Modal.Title>
                        <p className="page-heading">{title}</p>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='modal-body-text' >
                    {message.map((x, i) => (
                        <p style={{ textAlign: "center" }} key={i}>
                            {x}
                        </p>
                    ))}
                </Modal.Body>
                <Modal.Footer className='modal-buttons'>
                    <button className='primary-button-red' type='button' onClick={(e) => { handleSubmit(e) }}>{submitButtonLabel}</button>

                    {optionalThirdButtonLabel && optionalThirdButtonLabel !== "" &&
                        <button className='primary-button' type='button' onClick={(e) => { optionalThirdOption(e) }}>{optionalThirdButtonLabel}</button>
                    }

                    <button className='tertiary-button' type='button' onClick={() => handleCloseModal()}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default ConfirmationModalComp;